import React, { useState, useEffect } from 'react'
import { Box, Select, Flex, Group, Button, Avatar, Text, Loader, FocusTrap } from '@mantine/core'
import { getListUsers } from '../../../../../services/users'
import { useDebouncedCallback } from '@mantine/hooks'
import { IconCheck } from '@tabler/icons-react'
import { validation } from '../../../../../plugins/validation'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'
import { updateExclusiveUser, updateRecommendUser, editProduct } from '../../../../../services/products'
import { useSelector } from 'react-redux'

const defaultVal = {
  user_id: ''
}

const formValidation = {
  user_id: {
    isError: false,
    message: ''
  }
}

const FormAddInsightUserProduct = ({ idProduct, userState, dataRecentUser, onCloseForm, reloadDetail }) => {
  const { minimumPayload } = useSelector(state => state.product_detail)
  const [loadingUsers, setLoadingUsers] = useState(true)
  const [searchUser, setSearchUser] = useState('')
  const [userList, setUserList] = useState([])
  const [formData, setFormData] = useState(defaultVal)
  const [validationForm, setValidationForm]= useState(formValidation)
  const [loadingForm, setLoadingForm] = useState(false)

  const generatePayload = () => {
    return {
      ...minimumPayload,
    }
  }

  const handleSubmitUser = async (form) => {
    setLoadingForm(true)
    setValidationForm(formValidation)

    let methodFunction = null
    let captionMessageError = ''
    const titleMessageSuccess = 'Add User Successfully'
    const captionMessageSuccess = 'You have been added new user'
    const titleMessageError = 'Add User Failed'

    const isError = validation(form, setValidationForm)

    if (isError) {
      setLoadingForm(false)
      return
    }
    if (userState === 'recommendation') {
      const dataUser = dataRecentUser.map((val)=> {
        return val.id
      })
      dataUser.push(Number(form.user_id))
      const payload = {
        users: dataUser
      }
      methodFunction = updateRecommendUser(idProduct, payload)
    } else if (userState === 'exclusive') {
      const dataUser = dataRecentUser.map((val)=> {
        return val.id
      })
      dataUser.push(Number(form.user_id))
      const payload = {
        users: dataUser
      }
      methodFunction = updateExclusiveUser(idProduct, payload)
    } else if (userState === 'owner-list') {
      const dataUser = dataRecentUser.map((val)=> {
        return val.id
      })
      dataUser.push(Number(form.user_id))
      const payload = generatePayload()
      payload.user_ids = dataUser
      methodFunction = editProduct(idProduct, payload)
    }
    try {
      const response = await methodFunction
      if (response.success) {
        notificationSuccess(titleMessageSuccess, captionMessageSuccess)
        onCloseForm()
        reloadDetail()
      }
    } catch (error) {
      console.log(error)
      captionMessageError = error?.response?.data?.message || 'There was an error while adding user.'
      notificationError(titleMessageError, captionMessageError)
    } finally {
      setLoadingForm(false)
    }
  }


  const handleGetUsers = useDebouncedCallback(async (dataRecentUser) => {
    setLoadingUsers(true)
    const remapFilterRecentUser = dataRecentUser.map((val) => {
      return val.id
    })
    const parameter = {
      'filter[name][like]': searchUser,
      'page[num]': 1,
      'page[limit]': 8,
      'sort': '-created_at',
      'filter[id][not]': remapFilterRecentUser.toString()
    }
    try {
      const response = await getListUsers(parameter)
      const { data } = response.data
      const remap = data.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name,
          email: val.attributes.email
        }
      })
      setUserList(remap)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingUsers(false)
    }
  }, 300)

  useEffect(() => {
    handleGetUsers(dataRecentUser)
    // eslint-disable-next-line
  }, [searchUser, dataRecentUser])

  const renderUserOption = ({ option, checked }) => {
    return (
      <Group flex="1" align='center' gap="xs">
        <Flex gap='sm' align='center'>
          <Avatar variant='filled' name={option.label} radius="xl" size="sm" color='red' />
          <Box>
            <Text fz={12} fw='600' lineClamp={2}>{option.label}</Text>
            <Text fz={10} fw='500' c='gray.6' lineClamp={2}>{option.email}</Text>
          </Box>
        </Flex>
        {checked && <IconCheck style={{ marginInlineStart: 'auto' }} />}
      </Group>
    )
  }

  const loadingDataTemplate = () => {
    return (
      <Box ta='center' my={12}>
        <Loader size={16} />
        <Text c='gray.6' fz={11}>Loading Data</Text>
      </Box>
    )
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  return (
    <Box>
      <FocusTrap.InitialFocus />
      <Box mb='sm'>
        <Select
          name='user_id'
          value={formData.user_id}
          label='Select User'
          data={userList}
          renderOption={renderUserOption}
          onChange={(val) => handleChangeForm('user_id', val)}
          error={validationForm.user_id.isError ? `${validationForm.user_id.message}` : ''}
          size='xs'
          searchable
          searchValue={searchUser}
          onSearchChange={setSearchUser}
          nothingFoundMessage={!loadingUsers ? userList.length > 0 ? '' : 'No User Found' : loadingDataTemplate()}
          clearable
        />
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
            <Button size='xs' variant="filled" loading={loadingForm} onClick={() => handleSubmitUser(formData)}>Submit</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAddInsightUserProduct